import LOGO from "../images/UTPaquime.png";

export const Team__UTPaquime = {
  name: "UT Paquime",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#007A6D",
  teamJerseyColor: "#0F172A",

  // Stats
  gamesWon: 0,
  gamesLost: 4,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 22 + 15 + 16 + 18,
  goalsScoredAgainst: 61 + 40 + 34 + 20,
  defaultGoals: 0,

  dontShowPointDif: true,
  isChampion: false,
  isEliminated: false,

  players: [],
};
